import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Header, Title, ContainerHeader, ContainerButtons } from '../components/Header';
import Button from '../components/Button';
import { Input, SpanError, CustomForm } from '../components/Elements';
import { ReactComponent as SvgLogin } from '../images/registro.svg';
import styled from 'styled-components';
import { auth } from '../firebase/firebaseConfig';
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import ModalApproval from '../components/ModalApproval';
import { useNavigate } from 'react-router-dom';

const Svg = styled(SvgLogin)`
    width: 100%;
    max-height: 6.25rem; /* 100px */
    margin-bottom: 1.25rem; /* 20px */
`;

const RegisterContainer = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [message, setMessage] = useState({});
    const [showModal, setShowModal] = useState(false);

    const handleChange = (e) => {
        switch(e.target.name){
            case 'email':
                setEmail(e.target.value);
                break;
            case 'password':
                setPassword(e.target.value);
                break;
            case 'password2':
                setPassword2(e.target.value);
                break;
            case 'empresa':
                setEmpresa(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({});

        // Comprobamos del lado del cliente que el correo sea válido.
        const expresionRegular = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
        if (!expresionRegular.test(email)) {
            setMessage({
                tipo: 'error',
                message: 'Por favor ingresa un correo electrónico válido'
            });
            return;
        }

        if (email === '' || password === '' || password2 === '' || empresa === '') {
            setMessage({
                tipo: 'error',
                message: 'Por favor rellena todos los datos'
            });
            return;
        }

        if (password !== password2) {
            setMessage({
                tipo: 'error',
                message: 'Las contraseñas no son iguales'
            });
            return;
        }

        try {
			const userCredential = await createUserWithEmailAndPassword(auth, email, password);
			const user = userCredential.user;
	
			// Guardar en Firestore
			await setDoc(doc(db, "config", user.uid), {
				name: empresa,
                userId: user.uid,
                approved: false,
                categories: [],
                places: []
			});
	
			setShowModal(true);
        } catch (error) {
            let message;
            switch (error.code) {
                case 'auth/invalid-password':
                    message = 'La contraseña tiene que ser de al menos 6 caracteres.';
                    break;
                case 'auth/email-already-in-use':
                    message = 'Ya existe una cuenta con el correo electrónico proporcionado.';
                    break;
                case 'auth/invalid-email':
                    message = 'El correo electrónico no es válido.';
                    break;
                default:
                    message = 'Hubo un error al intentar crear la cuenta.';
                    break;
            }

            setMessage({ tipo: 'error', message: message });
        }
    }

    return (
        <>
            <Helmet>
                <title>Crear Cuenta</title>
            </Helmet>

            <Header>
                <ContainerHeader>
                    <Title>Crear Cuenta</Title>
                    <div>
                        <Button to="/login">Iniciar Sesión</Button>
                    </div>
                </ContainerHeader>
            </Header>

            <CustomForm onSubmit={handleSubmit}>
                <Svg />
                <Input 
                    type="text"
                    name="empresa"
                    placeholder="Nombre de la Empresa"
                    value={empresa}
                    onChange={handleChange}
                />
                <Input 
                    type="email"
                    name="email"
                    placeholder="Correo Electrónico"
                    value={email}
                    onChange={handleChange}
                />
                <Input 
                    type="password"
                    name="password"
                    placeholder="Contraseña"
                    value={password}
                    onChange={handleChange}
                />
                <Input 
                    type="password"
                    name="password2"
                    placeholder="Repetir la contraseña"
                    value={password2}
                    onChange={handleChange}
                />
                <ContainerButtons>
                    <Button as="button" type="submit">Crear Cuenta</Button>
                </ContainerButtons>
            </CustomForm>
            <SpanError>{message.message}</SpanError>

            {showModal && <ModalApproval onClose={() => {
                setShowModal(false);
                navigate('/login');
            }} />}


        </>
    );
}

export default RegisterContainer;
